export const DEFAULT_TITLE = 'Something is wrong here...';

export const DEFAULT_MESSAGE =
  'Sorry, we’re unable to fetch details at the moment';
